import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

/* ─── Scroll-triggered wrapper ─── */
export function Reveal({ children, className = '', delay = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  return (
    <motion.div ref={ref} className={className}
      initial={{ opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay, ease: [0.25, 0.1, 0.25, 1] }}>
      {children}
    </motion.div>
  );
}

/* ─── Browser Frame ─── */
export function BrowserFrame({ src, alt, route = '' }) {
  return (
    <div className="rounded-2xl overflow-hidden border border-gray-200/80 shadow-[0_8px_30px_rgb(0,0,0,0.08)] bg-[#F5F5F7] hover:shadow-[0_20px_60px_rgb(0,0,0,0.12)] transition-shadow duration-500">
      <div className="h-9 bg-gradient-to-b from-[#ECECEE] to-[#E4E4E8] flex items-center px-4 gap-2 border-b border-gray-200/50">
        <div className="flex gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#28C840]" />
        </div>
        {route && (
          <div className="flex-1 flex justify-center">
            <div className="bg-white/70 rounded-md px-4 py-0.5 text-[10px] text-[#86868B] font-medium tracking-wide shadow-inner border border-gray-200/40">smarto.com/{route}</div>
          </div>
        )}
      </div>
      <img src={src} alt={alt} className="w-full" loading="lazy" />
    </div>
  );
}
